import { fontWeight } from '@mui/system';
import React, { useState, useEffect } from 'react';
import { MdAttachFile } from "react-icons/md";
import ImageBase64 from './ImageBase64';

const FileAttachment_Multi = ({ data, dispatch, buttonText, maxNumOfFiles, uploadImage, id, funcToRun, classesToAdd, triggerUpdateFromParent, valueInField, maxFiles }) => {
  const [currentFile, setCurrentFile] = useState();
  const [encodedData, setEncodedData] = useState("");
  const [fileList, setFileList] = useState(valueInField);
  const [runCount, setRunCount] = useState(0)
  const [totalFileSize, setTotalFileSize] = useState(0);


  const handleOnChange = (e) =>{
    if (fileList.length >= maxFiles){
      alert("You cannot add more then "+maxFiles+" files")
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];

    //alert("STARTING FILE SIZE: " + totalFileSize)

    if (file.size+totalFileSize>8000000){
      alert("File could not be added. The total size of your files exceeds the 10MB limit.")
      e.target.value = null;
      return;
    }    

    let currList = fileList;

    for (var i = 0; i < currList.length; i++){
      if (currList[i].name == file.name){
        alert("Attention: This file has already been added")
        e.target.value = null;
        return;
      }
    }

    setTotalFileSize(totalFileSize + parseInt(file.size));
    getBase64FileContents(file)
    e.target.value = null;
  }

  const getBase64FileContents = async (file) => {
    const base64 = await convertBase64(file);
    var tempJSON = {
      name: '',
      content: '',
      size: 0
    }
    tempJSON.name = file.name;
    tempJSON.content = base64;
    tempJSON.size = file.size;
    var currList = fileList;
    currList.push(tempJSON)
    setFileList(currList)
    triggerUpdateFromParent(fileList)
    setRunCount(runCount+1)
  }

  useEffect(() => {
    //renderFileUI();
  }, [runCount]);

  const removeFile = (e) =>{
    const removeId = e.target.dataset.remove;
    let currList = fileList;
    for (var i = 0; i < currList.length; i++){
      if (currList[i].name == removeId){
        //alert("FOUND: " + removeId)
        //console.log(currList[i].size)
        setTotalFileSize(totalFileSize-currList[i].size)
        //alert("FILE SIZE AFTER REMOVAL: " + totalFileSize)
        currList.splice(i, 1);
      }
    }
    setFileList(currList)
    triggerUpdateFromParent(currList)
    setRunCount(runCount+1)
  }
  
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result)
        }

        fileReader.onerror = (error) => {
            reject(error);
        }
    })
  }

  function renderMaxFilesReached(){
    if (fileList.length >= maxFiles){
        return <p style={{color: "#3f51b5", textAlign: "center", fontWeight: "600"}}>*Max amount of files allowed</p>
    }
    else return <></>
}

  return (
    <div>
      <label for={id} class={"custom-file-upload "+classesToAdd}>
       <MdAttachFile /> Select from a folder on your computer
      </label>
      <input 
        id={id} 
        type="file" 
        name="image"
        className="unselectable"
        accept=""
        onChange={(e) => { handleOnChange(e) }}
        required
      />
      <ol className="dropped-files">
          {fileList.map(f => {
          return (
              <div>
                <li key={f.name}>{f.name}&nbsp;
                 <button 
                  style={{color: "red", fontWeight: "800", backgroundColor: "rgba(51, 170, 51, 0)", position:"relative", top: "0px", width:"20px", height: "25px", padding: "0px", borderRadius: "4px"}} data-remove={f.name} onClick={(e)=>removeFile(e)}>
                    x
                  </button>
                </li>
              </div>
          )
        })}
        </ol>
        {renderMaxFilesReached()}
    </div>
  );
}
export default FileAttachment_Multi;
